import { useEffect, useState } from "react";
import type { CrewMember } from "@/mocks/admin/crew";

type Props = {
  member: CrewMember;
  onSwitch?: () => void;
  greeting?: string;
};

export default function MoverHeader({ member, onSwitch, greeting }: Props) {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30 * 1000);
    return () => clearInterval(id);
  }, []);

  const hour = now.getHours();
  const auto =
    hour < 5 ? "Late shift" : hour < 12 ? "Good morning" : hour < 18 ? "Good afternoon" : "Good evening";

  const dateLabel = now.toLocaleDateString("en-US", {
    weekday: "long",
    month: "short",
    day: "numeric",
  });

  return (
    <header className="px-5 pt-7 pb-5 bg-ink-900 text-white relative overflow-hidden">
      <div className="absolute -right-12 -top-12 w-44 h-44 rounded-full bg-brand-500/30 blur-3xl"></div>
      <div className="absolute -left-10 -bottom-10 w-32 h-32 rounded-full bg-brand-400/10 blur-2xl"></div>
      <div className="relative flex items-center justify-between">
        <div className="min-w-0">
          <div className="text-[11px] uppercase tracking-[0.18em] text-brand-300 font-semibold">
            {greeting || auto}
          </div>
          <div className="font-display text-xl font-bold mt-1 truncate">{member.name.split(" ")[0]}</div>
          <div className="text-[11px] text-ink-300 mt-0.5">{dateLabel}</div>
        </div>
        {onSwitch ? (
          <button
            onClick={onSwitch}
            className="flex items-center gap-2 pl-2 pr-2.5 py-1.5 rounded-full bg-white/10 hover:bg-white/15 text-[11px] font-semibold cursor-pointer whitespace-nowrap backdrop-blur-sm border border-white/10"
          >
            <div className={`w-7 h-7 rounded-full ${member.color} text-white text-[11px] font-bold flex items-center justify-center`}>
              {member.initials}
            </div>
            <i className="ri-arrow-down-s-line text-base"></i>
          </button>
        ) : (
          <div className="flex items-center gap-2 pl-2 pr-2.5 py-1.5 rounded-full bg-white/10 text-[11px] font-semibold backdrop-blur-sm border border-white/10">
            <div className={`w-7 h-7 rounded-full ${member.color} text-white text-[11px] font-bold flex items-center justify-center`}>
              {member.initials}
            </div>
            <i className="ri-shield-check-line text-base text-emerald-300" title="Private link"></i>
          </div>
        )}
      </div>
    </header>
  );
}